import React from 'react'
import { isNullOrUndefined } from '../../utils'

// Renders a highlighted text component with optional top answer styling.


/**
 * Renders a highlighted text component with optional top answer styling.
 *
 * It takes in `text` and `highlight` props, where `text` is the full text to be
 * displayed and `highlight` is an object containing the `BeginOffset` and `EndOffset`
 * properties to indicate the start and end of the highlighted text.
 *
 * If the `TopAnswer` property in the `highlight` object is truthy, the highlighted
 * text will have a yellow background.
 *
 * @see {@link https://github.com/aws-solutions/kendra-chatbot-ui/blob/main/src/containers/Kendra/results/components/Highlight.jsx Highlight.jsx}
 * @param {Object} props - The component props.
 * @param {string} props.text - The text to be highlighted.
 * @param {Object} props.highlight - The highlight information.
 * @param {number} props.highlight.BeginOffset - The start index of the highlight.
 * @param {number} props.highlight.EndOffset - The end index of the highlight.
 * @param {boolean} [props.highlight.TopAnswer] - Whether the highlight is a top answer.
 * @returns {JSX.Element} The rendered highlighted text.
 */
const HighlightedText = ({ text, highlight }) => {
  // all highlights are bolded
  // if TopAnswer is provided and true, it has a yellow background
  return (
    <strong
      className={
        !isNullOrUndefined(highlight.TopAnswer) && highlight.TopAnswer
          ? 'top-answer strong'
          : 'strong'
      }
    >
      {!isNullOrUndefined(text) &&
        text?.substring(highlight.BeginOffset, highlight.EndOffset)}
    </strong>
  )
}

export default HighlightedText
